import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getCompanies, seedDatabase } from '@/lib/api';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Search, Building2, Menu, X, LogOut, User } from 'lucide-react';

var Home = function() {
  var _useState1 = useState([]);
  var companies = _useState1[0];
  var setCompanies = _useState1[1];
  
  var _useState2 = useState([]);
  var filteredCompanies = _useState2[0];
  var setFilteredCompanies = _useState2[1];
  
  var _useState3 = useState('');
  var search = _useState3[0];
  var setSearch = _useState3[1];
  
  var _useState4 = useState('Todas');
  var selectedCategory = _useState4[0];
  var setSelectedCategory = _useState4[1];
  
  var _useState5 = useState(true);
  var loading = _useState5[0];
  var setLoading = _useState5[1];
  
  var _useState6 = useState(false);
  var mobileMenuOpen = _useState6[0];
  var setMobileMenuOpen = _useState6[1];
  
  var navigate = useNavigate();

  // Get employee access info
  var employeeAccessStr = localStorage.getItem('employeeAccess');
  var employeeAccess = employeeAccessStr ? JSON.parse(employeeAccessStr) : {};

  var categories = ['Todas', 'Energías Renovables', 'Comercio', 'Construcción', 'Hostelería', 'Ocio', 'Consultoría', 'Otros Servicios'];

  var handleLogout = function() {
    localStorage.removeItem('employeeAccess');
    navigate('/');
  };

  useEffect(function() {
    loadCompanies();
  }, []);

  useEffect(function() {
    filterCompanies();
  }, [search, selectedCategory, companies]);

  var loadCompanies = async function() {
    try {
      var response = await getCompanies();
      if (response.data.length === 0) {
        await seedDatabase();
        var newResponse = await getCompanies();
        setCompanies(newResponse.data);
      } else {
        setCompanies(response.data);
      }
    } catch (error) {
      console.error('Error loading companies:', error);
      try {
        await seedDatabase();
        var resp = await getCompanies();
        setCompanies(resp.data);
      } catch (seedError) {
        console.error('Error seeding database:', seedError);
      }
    } finally {
      setLoading(false);
    }
  };

  var filterCompanies = function() {
    var filtered = companies.slice();
    
    if (search) {
      filtered = filtered.filter(function(c) {
        var nameMatch = c.name.toLowerCase().includes(search.toLowerCase());
        var descMatch = c.description ? c.description.toLowerCase().includes(search.toLowerCase()) : false;
        return nameMatch || descMatch;
      });
    }
    
    if (selectedCategory !== 'Todas') {
      filtered = filtered.filter(function(c) {
        return c.category === selectedCategory;
      });
    }
    
    setFilteredCompanies(filtered);
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      {/* Header */}
      <header className="bg-white border-b border-slate-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <Link to="/ofertas" className="flex items-center gap-3" data-testid="header-logo">
              <div className="flex items-center gap-3">
                <img 
                  src="https://customer-assets.emergentagent.com/job_619dfbd9-e9ac-4905-ae17-ad2e8903622d/artifacts/tnur302o_Firma%2020%20Aniversario%20%28251%20x%2088%20px%29%20%28350%20x%20100%20px%29%20%281%29%20%282%29%20%281%29.png" 
                  alt="Cámara Lanzarote" 
                  className="h-10 w-auto"
                />
                <img 
                  src="https://customer-assets.emergentagent.com/job_619dfbd9-e9ac-4905-ae17-ad2e8903622d/artifacts/ibo9k545_LOGO%20CLUB%20CA%CC%81MARA%20%2B%20SIN%20FONDO.png" 
                  alt="Club Cámara" 
                  className="h-12 w-auto"
                />
              </div>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-4">
              {employeeAccess.companyName && (
                <div className="flex items-center gap-2 text-sm text-[#64748B] bg-slate-100 px-3 py-1.5 rounded-full">
                  <User className="w-4 h-4" />
                  <span>{employeeAccess.companyName}</span>
                </div>
              )}
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={handleLogout}
                className="text-[#64748B] hover:text-[#d1223b]"
                data-testid="logout-btn"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Salir
              </Button>
            </nav>

            {/* Mobile menu button */}
            <button 
              className="md:hidden p-2 rounded-lg hover:bg-slate-100"
              onClick={function() { setMobileMenuOpen(!mobileMenuOpen); }}
              data-testid="mobile-menu-btn"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-slate-100 bg-white py-4 px-4">
            <nav className="flex flex-col gap-3">
              {employeeAccess.companyName && (
                <div className="flex items-center gap-2 text-sm text-[#64748B]">
                  <User className="w-4 h-4" />
                  <span>{employeeAccess.companyName}</span>
                </div>
              )}
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={handleLogout}
                className="justify-start text-[#64748B]"
              >
                <LogOut className="w-4 h-4 mr-2" />
                Cerrar sesión
              </Button>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section className="hero-gradient text-white py-12 md:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Descuentos Exclusivos
          </h2>
          <p className="text-lg md:text-xl text-white/80 mb-8 max-w-2xl mx-auto">
            Beneficios y ventajas exclusivas para las empresas del Club Cámara y sus profesionales.
          </p>
          
          {/* Search Bar */}
          <div className="max-w-xl mx-auto relative">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
            <Input
              type="text"
              placeholder="Buscar empresas..."
              value={search}
              onChange={function(e) { setSearch(e.target.value); }}
              className="pl-12 h-14 rounded-full text-[#0F172A] bg-white border-0 shadow-lg"
              data-testid="search-input"
            />
          </div>
        </div>
      </section>

      {/* Categories */}
      <section className="py-6 bg-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
            {categories.map(function(category) {
              return (
                <button
                  key={category}
                  onClick={function() { setSelectedCategory(category); }}
                  className={'px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ' + (
                    selectedCategory === category
                      ? 'bg-[#d1223b] text-white'
                      : 'bg-slate-100 text-[#64748B] hover:bg-slate-200'
                  )}
                  data-testid={'category-' + category.toLowerCase()}
                >
                  {category}
                </button>
              );
            })}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        {loading ? (
          <div className="flex justify-center items-center py-20">
            <div className="spinner"></div>
          </div>
        ) : (
          <div>
            {/* All Companies */}
            {filteredCompanies.length > 0 && (
              <section>
                <div className="flex items-center gap-3 mb-6">
                  <Building2 className="w-6 h-6 text-[#d1223b]" />
                  <h3 className="text-2xl font-bold text-[#0F172A]" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    Empresas Colaboradoras
                  </h3>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
                  {filteredCompanies.map(function(company, index) {
                    return <CompanyCard key={company.id} company={company} index={index} />;
                  })}
                </div>
              </section>
            )}

            {/* No results */}
            {filteredCompanies.length === 0 && !loading && (
              <div className="text-center py-20">
                <Building2 className="w-16 h-16 text-slate-300 mx-auto mb-4" />
                <h3 className="text-xl font-semibold text-[#0F172A] mb-2">No se encontraron empresas</h3>
                <p className="text-[#64748B]">Intenta con otra búsqueda o categoría</p>
              </div>
            )}
          </div>
        )}
      </main>

      {/* Footer */}
      <footer className="bg-[#0F172A] text-white py-8 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-3">
                <img 
                  src="https://customer-assets.emergentagent.com/job_619dfbd9-e9ac-4905-ae17-ad2e8903622d/artifacts/tnur302o_Firma%2020%20Aniversario%20%28251%20x%2088%20px%29%20%28350%20x%20100%20px%29%20%281%29%20%282%29%20%281%29.png" 
                  alt="Cámara Lanzarote" 
                  className="h-8 w-auto"
                />
                <img 
                  src="https://customer-assets.emergentagent.com/job_619dfbd9-e9ac-4905-ae17-ad2e8903622d/artifacts/ibo9k545_LOGO%20CLUB%20CA%CC%81MARA%20%2B%20SIN%20FONDO.png" 
                  alt="Club Cámara" 
                  className="h-10 w-auto"
                />
              </div>
            </div>
            <p className="text-slate-400 text-sm">
              © 2026 Cámara de Comercio de Lanzarote y La Graciosa
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

var CompanyCard = function(props) {
  var company = props.company;
  var index = props.index;
  
  var handleImageError = function(e) {
    e.target.onerror = null;
    e.target.src = 'https://placehold.co/200x200/f1f5f9/d1223b?text=' + encodeURIComponent(company.name.substring(0, 2));
  };
  
  return (
    <Link
      to={'/empresa/' + company.id}
      className="company-card bg-white rounded-xl p-4 md:p-6 border border-slate-100 shadow-sm hover:shadow-md transition-all group cursor-pointer flex flex-col items-center justify-center gap-3 text-center h-full stagger-item"
      style={{ animationDelay: (index * 50) + 'ms' }}
      data-testid={'company-card-' + company.id}
    >
      <div className="w-20 h-20 md:w-24 md:h-24 rounded-xl overflow-hidden bg-slate-50 flex items-center justify-center group-hover:scale-105 transition-transform">
        {company.logo_url ? (
          <img 
            src={company.logo_url} 
            alt={company.name}
            className="w-full h-full object-contain"
            onError={handleImageError}
          />
        ) : (
          <div className="w-full h-full bg-[#d1223b]/10 flex items-center justify-center">
            <span className="text-2xl font-bold text-[#d1223b]">{company.name.substring(0, 2)}</span>
          </div>
        )}
      </div>
      <div>
        <h4 className="font-semibold text-[#0F172A] text-sm md:text-base line-clamp-2 group-hover:text-[#d1223b] transition-colors">
          {company.name}
        </h4>
        {company.category && (
          <p className="text-xs text-[#64748B] mt-1">{company.category}</p>
        )}
      </div>
    </Link>
  );
};

export default Home;
